import { sendPersonaSession } from './api'

export const languageMap: Record<string, string> = {
  en: 'en-US',
  zh: 'zh-CN',
  fr: 'fr'
}

export const handleEvents = (name: string, meta: any, templateId: string) => {
  const inquiryId = meta?.inquiryId as string
  // const sessionToken = meta?.sessionToken as string

  switch (name) {
    case 'start':
      try {
        sendPersonaSession(inquiryId)
      } catch (error) {
        console.error('Error sending event to backend', error)
      }
      break

    // case 'exit':
    //   if (inquiryId && sessionToken) {
    //     const sessionData = {
    //       inquiryId,
    //       sessionToken
    //     }
    //     sessionStorage.setItem(templateId, JSON.stringify(sessionData))
    //   }
    //   break

    default:
      break
  }
}

export const getPreviousInquiry = (templateId: string) => {
  const storedInquiry = sessionStorage.getItem(templateId)
  const inquiryData = storedInquiry ? JSON.parse(storedInquiry) : null
  const hasPreviousInquiry = Boolean(inquiryData?.inquiryId && inquiryData?.sessionToken)

  return { inquiryData, hasPreviousInquiry }
}
